import React, { useContext, useEffect, useMemo, useState } from 'react';
import { CssBaseline, Grid, Snackbar, Tooltip, IconButton, Paper, Button, useMediaQuery, useTheme, Badge } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from "lodash/fp";
import useStyles from '../../common/CommonStyle/CommonStyle';
import { GridToolbarColumnsButton, GridToolbarDensitySelector, LicenseInfo, DataGridPro, getGridDateOperators } from '@mui/x-data-grid-pro';
import { ModuleAccessPermissionKey } from '../../../Constants/ModuleAccessKey';
import GridTextLocalization from '../../common/GridTextLocalization/GridTextLocalization';
import { GlobalEdiApiConstants } from '../../../Constants/GlobalEdiApiConstants';
import { LoggedInUserDetails } from '../../common/LoggedInUserDetails/LoggedInUserDetails';
import { SupportedLanguageDetails } from '../../common/SupportedLanguageDetails/SupportedLanguageDetails';
import IconSettings from '@mui/icons-material/Settings';
import IconSupplier from '@mui/icons-material/LocalShipping';
import IconEmailMessageConfig from '@mui/icons-material/ContactMail';
import { CommonService } from '../../../services';
import CreateIcon from '@mui/icons-material/Add';
import ViewIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/EditOutlined';
import { CustomFilters } from '../../common/CustomFilters/CustomFilters';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Alert } from '@mui/lab';
import CommonGridPagination from '../../common/CommonGridPagination/CommonGridPagination';
import IconUserManagement from '@mui/icons-material/AccountCircle';
import EmailMessageConfigDiaglog from '../../../components/BPEmailMessageConfig/EmailMessageConfigDialog';
import CustomFilterComponent, { GetFilterableColumns } from '../../common/CustomFilterComponent';
import { FilterList } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ConfirmationDialog from '.././../common/ConfirmationDialog';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import CustomBreadCrumb from '../../../components/common/CustomBreadCrumb';
import CustomsValuationEmailEditConfigDialog from './EditCustomsVauationDialog';

const columnFieldsName = {
    contactName: 'contactName',
    contactSalutation: 'contactSalutation',
    project: 'project',
    countryCode: 'countryCode',
    contactNo: 'contactNo',
    emailTo: 'emailTo',
    emailCc: 'emailCc',
    emailBcc: 'emailBcc',
    // bpType: 'bpType',
    // bpCode: 'bpCode',
    bpName: 'bpName',
    status: 'status',
    createdTime: 'createdTime',
    createdBy: 'createdBy',
    updatedTime: 'updatedTime',
    updatedBy: 'updatedBy',
    validFrom: 'validFrom',
    validTo: 'validTo',
    entityContact: 'user.userName',
    alertEmailFrequency: 'alertEmailFrequency',
    evaluationConfirmationEmailFrequency: 'evaluationConfirmationEmailFrequency',
    alertActive: 'alertActive',
    evaluationActive: 'evaluationActive',


    custValConfigId: 'custValConfigId',
    source: 'source',
    countryCode: 'countryCode',
    contactNo: 'contactNo',
    emailTo: 'emailTo',
    emailCc: 'emailCc',
    validFrom: 'validFrom',
    validTo: 'validTo',
    createdBy: 'createdBy',
    createdTime: 'createdTime',
    status: 'status',
    entity: 'entity.erpEntityCode'
}

const CustomsValuationEmailMsgConfig = (props) => {
    const classes = useStyles();
    const intl = useIntl();
    const theme = useTheme();
    const { mode, componentListForBp } = props;
    const X_GRID_LICENSE_KEY = `${process.env.REACT_APP_X_GRID_LICENSE_KEY}`.toString();
    LicenseInfo.setLicenseKey(
        X_GRID_LICENSE_KEY,
    );
    const moduleAccessKeyPermission = ModuleAccessPermissionKey();
    const { loggedInUserInfo } = useContext(LoggedInUserDetails);
    const emailMessageConfigModuleAccess = loggedInUserInfo.roleModuleAccess[moduleAccessKeyPermission.CustomsValuationEmailMsgConfig];
    const selectedLanguage = useContext(SupportedLanguageDetails);
    const localtext = GridTextLocalization();
    const apiUrlAndParamBodyConstants = GlobalEdiApiConstants();
    const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [preference, setPreference] = useState(
        apiUrlAndParamBodyConstants.paramBodyForGetListApis.userPreference
    );
    const [pinnedColumns, setPinnedColumns] = useState(preference.columnsPinned);

     function orderAndHideColumns(savedUserPreference, defaultUserPreference) {
            if (savedUserPreference.length !== 0 && defaultUserPreference.length !== 0) {
                var orderedUserPreferences = [],
                    len = defaultUserPreference.length,
                    len_copy = len,
                    index, current;
    
                for (; len--;) {
                    current = defaultUserPreference[len];
                    index = savedUserPreference.findIndex(element => element.field === current.field);
                    orderedUserPreferences[index] = current;
                    orderedUserPreferences[index].hide = savedUserPreference[index].hide;
                }
    
                Array.prototype.splice.apply(defaultUserPreference, [0, len_copy].concat(orderedUserPreferences));
                return orderedUserPreferences;
            }
        }

        useEffect(() => {
            saveLastOpenedScreen(componentList[1].name.props.id)
                .then((response) => { })
                .catch(function (error) {
                    if (error.response !== undefined) {
                        setAlertBoxState({ ...alertBoxState, openAlert: true, message: error.response.data.message, severity: "error" });
                    }
                });
        }, []);
    
        useEffect(() => {
            loadLastOpenScreen()
                .then((response) => {
                    if (response.data) {
                        setPreference(response.data);
                        setPinnedColumns(response.data.columnsPinned);
                    }
                })
                .catch(function (error) {
                    if (error.response !== undefined) {
                        setAlertBoxState({ ...alertBoxState, openAlert: true, message: error.response.data.message, severity: "error" });
                    }
                });
        }, []);

    const pageLabelsConstantsAndMessages = {
        label: {
            createButton: 'Create',
            editButton: 'Edit',
            refreshButton: 'Refresh',
            applyFilterButton: 'Apply Filter',
            columns: 'Columns to View',
            filters: 'Filter the columns',
            Density: 'Density',
        },
        alignment: {
            alignLeft: 'left',
            alignRight: 'right',
            alignCenter: 'center',
        },
        name: {
            name: 'name'
        }
    };

    const componentList = [
        {
            path: undefined,
            name: <FormattedMessage id="common.menu.breadcrumb.settings" defaultMessage="Settings" />,
            iconName: IconSettings,
        },
        {
            path: "/customsValuationMsgConfig",
            name: <FormattedMessage id="common.module.breadcrumb.columnname.customsValuationEmailMsgConfig" />,
            iconName: ContactMailIcon,
        }
    ];

    const [alertBoxState, setAlertBoxState] = React.useState({
        openAlert: false,
        vertical: 'top',
        horizontal: 'center',
        message: '',
        severity: ''
    });
    const handleCloseAlert = () => {
        setAlertBoxState({ ...alertBoxState, openAlert: false });
    };
    const { vertical, horizontal, openAlert, message, severity } = alertBoxState;

    const [paramBody, setParamBody] = useState({ ...apiUrlAndParamBodyConstants.paramBodyForGetListApis.customsValuationEmailMsgConfig });

    const [tableLoadingStatus, setTableLoadingStatus] = useState(false);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [refreshTable, setRefreshTable] = useState(false);
    const [OpenEmailMessageConfigDialog, setOpenEmailMessageConfigDialog] = useState(false);
    const [modeForEmailConfig, setModeForEmailConfig] = useState('');
    const [emailMessageConfigObjectToBeEditedOrView, setEmailMessageConfigObjectToBeEditedOrView] = useState({});

    const [openFilterPanel, setFilterPanel] = useState(false);
    const handleClose = () => {
        setFilterPanel(false);
    }
    const [filterCount, setFilterCount] = React.useState(0);
    const defaulSelectedFilters = [];
    const [selectedFilters, setSelectedFilters] = useState([]);

    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

    const [primaryKeyOfSelectedRow, setPrimaryKeyOfSelectedRow] = useState(0);
    const [confirmationMessage, setConfirmationMessage] = useState('');

    const [callSaveApiForOrderVisibility, setCallSaveApiForOrderVisibility] = useState(false);
    const [intialParamBodyApiCall, setIntialParamBodyApiCall] = useState(false);

    const closeEmailMessageConfigDialog = (confirmed) => {
        setRefreshTable(prev => !prev);
        setEmailMessageConfigObjectToBeEditedOrView({});
        setOpenEmailMessageConfigDialog(false);
    }

    const savePreference = (preferenceChangeIn, params) => {
        if (preferenceChangeIn === "visibility" || preferenceChangeIn === "order") {
            var splicedFirstColumn = params;
            if (params[0].field === "__check__")
                splicedFirstColumn = params.splice(1, params.length);
            setCallSaveApiForOrderVisibility(true);
            setPreference(prev => ({ ...prev, columnsOrdervisible: splicedFirstColumn }));
        }
    }

    const saveLastOpenedScreen = (screenName) => {
        const preferencesParams = apiUrlAndParamBodyConstants.paramBodyForGetListApis.tablePreference.body;
        preferencesParams.userId = CommonService.getUserIdLoggedInUser();
        const org = CommonService.getOrganizationOfLoggedInUser();
        const entity = CommonService.getEntityOfLoggedInUser();
        preferencesParams.organization.orgName = org.orgName;
        preferencesParams.organization.erpOrgCode = org.erpOrgCode;
        preferencesParams.entity.erpEntityCode = entity.erpEntityCode;
        preferencesParams.entity.entityName = entity.entityName;
        preferencesParams.screenName = screenName;
        return CommonService.saveOrUpdateOrPost(
            apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen.lastLoggedInScreen,
            preferencesParams
        );
    }

    const loadLastOpenScreen = () => {
        const userPreferencesParamBody = apiUrlAndParamBodyConstants.paramBodyForGetListApis.tablePreference;
        userPreferencesParamBody.body.userId = CommonService.getUserIdLoggedInUser();
        const org = CommonService.getOrganizationOfLoggedInUser();
        const entity = CommonService.getEntityOfLoggedInUser();
        userPreferencesParamBody.body.organization.orgName = org.orgName;
        userPreferencesParamBody.body.organization.erpOrgCode = org.erpOrgCode;
        userPreferencesParamBody.body.entity.erpEntityCode = entity.erpEntityCode;
        userPreferencesParamBody.body.entity.entityName = entity.entityName;
        return CommonService.GetListApi(
            apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen.lastLoggedInScreen,
            { body: JSON.stringify(userPreferencesParamBody.body) }
        );
    }

    const saveGridPreferences = (preferencesParams) => {
        preferencesParams.userId = CommonService.getUserIdLoggedInUser();
        const org = CommonService.getOrganizationOfLoggedInUser();
        const entity = CommonService.getEntityOfLoggedInUser();
        preferencesParams.organization.orgName = org.orgName;
        preferencesParams.organization.erpOrgCode = org.erpOrgCode;
        preferencesParams.entity.erpEntityCode = entity.erpEntityCode;
        preferencesParams.entity.entityName = entity.entityName;
        preferencesParams.createdBy = CommonService.getLoggedInUserInfo().userName;
        preferencesParams.updatedBy = CommonService.getLoggedInUserInfo().userName;
        if (preferencesParams.createdBy !== undefined)
            return CommonService.saveOrUpdateOrPost(
                apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen.userPreferences,
                preferencesParams
            );
    }

    const loadUserPreferences = (preferencesParams) => {
        preferencesParams.body.userId = CommonService.getUserIdLoggedInUser();
        const org = CommonService.getOrganizationOfLoggedInUser();
        const entity = CommonService.getEntityOfLoggedInUser();
        preferencesParams.body.organization.orgName = org.orgName;
        preferencesParams.body.organization.erpOrgCode = org.erpOrgCode;
        preferencesParams.body.entity.erpEntityCode = entity.erpEntityCode;
        preferencesParams.body.entity.entityName = entity.entityName;
        return CommonService.GetListApi(
            apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen.userPreferences,
            { body: JSON.stringify(preferencesParams.body) }
        );
    }
    const commonBreadCrumbToBeUsedForDialog = componentList;

    const columnsForEmailMessageConfig =
        [
            {
                field: 'action',
                headerName: intl.formatMessage({ id: "columnname.action.label" }),
                width: mode === 'read' ? 100 : 130,
                sortable: false,
                hide: false,
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns,
                renderCell: (cellParams) => (
                    <div>
                        {(emailMessageConfigModuleAccess !== undefined ? emailMessageConfigModuleAccess.editFlag : false) && (mode !== 'read') && (
                            <Tooltip title={<FormattedMessage id="common.tooltip.breadcrumb.edit" defaultMessage="Edit" />}
                                placement='bottom' className={classes.actionButton} onClick={(() => {
                                    setModeForEmailConfig('edit');
                                    setEmailMessageConfigObjectToBeEditedOrView(cellParams.row);
                                    setOpenEmailMessageConfigDialog(true)
                                })}>
                                <span>
                                    <IconButton className={classes.customeToolbar} size="large">
                                        <EditIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>)}
                        {(emailMessageConfigModuleAccess !== undefined ? emailMessageConfigModuleAccess.readFlag : false) && (
                            <Tooltip title={<FormattedMessage id="common.button.view.breadcrumb.tooltip" defaultMessage={pageLabelsConstantsAndMessages.label.readButton} />}
                                placement='bottom' className={classes.actionButton} onClick={(() => {
                                    setModeForEmailConfig('read')
                                    setEmailMessageConfigObjectToBeEditedOrView(cellParams.row)
                                    setOpenEmailMessageConfigDialog(true)
                                })}>
                                <span>
                                    <IconButton className={classes.customeToolbar} size="large">
                                        <ViewIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>)}
                        {(emailMessageConfigModuleAccess !== undefined ? emailMessageConfigModuleAccess.deleteFlag : false) && (mode !== 'read') &&
                            (<Tooltip title={<FormattedMessage id="common.button.delete.tooltip" defaultMessage="Delete" />}
                                placement='bottom' className={classes.actionButton} onClick={(() => {
                                    handleDelete(cellParams.row.custValConfigId);
                                })}>
                                <span>
                                    <IconButton color='secondary' size="large">
                                        <DeleteIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>)}
                    </div>
                )
            },
            {
                field: columnFieldsName.emailTo,
                headerName: intl.formatMessage({ id: "textfield.bpemailto.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 350,
                sortable: true,
                filterable: false,
                type: 'string',
                hide: false,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.emailCc,
                headerName: intl.formatMessage({ id: "textfield.bpemailfrom.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 350,
                sortable: true,
                filterable: false,
                type: 'string',
                hide: false,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.emailBcc,
                headerName: intl.formatMessage({ id: "textfield.bpemailbcc.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 350,
                sortable: true,
                filterable: false,
                type: 'string',
                hide: false,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.updatedBy,
                headerName: intl.formatMessage({ id: "columnname.updatedby.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 155,
                sortable: true,
                type: 'string',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.updatedTime,
                headerName: intl.formatMessage({ id: "columnname.updateddate.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 180,
                sortable: true,
                type: 'string',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns,
                renderCell: (cellParams) => {
                    const rawDate = cellParams.row.updatedTime;

                    if (!rawDate) return <span></span>;

                    const date = new Date(rawDate);

                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
                    const day = String(date.getDate()).padStart(2, '0');

                    const hours = String(date.getHours()).padStart(2, '0');
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    const seconds = String(date.getSeconds()).padStart(2, '0');

                    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

                    return <span>{formattedDateTime}</span>;
                }

            },
            {
                field: columnFieldsName.createdBy,
                headerName: intl.formatMessage({ id: "columnname.columnnamecreatedby.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 150,
                sortable: true,
                type: 'string',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.createdTime,
                headerName: intl.formatMessage({ id: "columnname.createddate.label" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 180,
                sortable: true,
                type: 'string',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns,
                renderCell: (cellParams) => {
                    const rawDate = cellParams.row.createdTime;

                    if (!rawDate) return <span></span>;

                    const date = new Date(rawDate);

                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
                    const day = String(date.getDate()).padStart(2, '0');

                    const hours = String(date.getHours()).padStart(2, '0');
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    const seconds = String(date.getSeconds()).padStart(2, '0');

                    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

                    return <span>{formattedDateTime}</span>;
                }

            },
            {
                field: columnFieldsName.alertEmailFrequency,
                headerName: intl.formatMessage({ id: "columnname.textfield.label.alertEmail" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 200,
                sortable: true,
                type: 'string',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.evaluationConfirmationEmailFrequency,
                headerName: intl.formatMessage({ id: "columnname.textfield.label.EvaluationEmail" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
                width: 355,
                sortable: true,
                type: 'string',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns
            },
            {
                field: columnFieldsName.alertActive,
                headerName: intl.formatMessage({ id: "columnname.alertactive.label", defaultMessage: "Alert Email Status" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                width: 150,
                sortable: true,
                type: 'boolean',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns,
                renderCell: CommonService.customRenderStatusColumn
            },
            {
                field: columnFieldsName.evaluationActive,
                headerName: intl.formatMessage({ id: "columnname.evaluationactive.label", defaultMessage: "Evaluation Email Status" }),
                headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
                width: 200,
                sortable: true,
                type: 'boolean',
                hide: false,
                filterable: false,
                renderHeader: CommonService.customRenderHeaderColumns,
                renderCell: CommonService.customRenderStatusColumn
            },



        ]

    const [columns, setColumns] = useState([]);
    
    const [tableData, setTableData] = useState([]);

   useEffect(() => {
        let currentPreference = { ...preference };

        if (callSaveApiForOrderVisibility === false)
            currentPreference.columnsOrdervisible = columns;

        if (callSaveApiForOrderVisibility === true
            && currentPreference.columnsOrdervisible !== undefined
            && currentPreference.columnsOrdervisible !== null
            && currentPreference.columnsOrdervisible?.length !== 0) {
            saveGridPreferences({
                userId: 0,
                organization: {},
                entity: {},
                screenName: componentList[1].name.props.id,
                tabName: componentList[1].name.props.id,
                preferences: JSON.stringify(currentPreference),
                lastOpen: true,
            }).then((response) => {
                if (callSaveApiForOrderVisibility === true) {
                    var defaultColumns = columns;
                    var userChangedColumns = currentPreference.columnsOrdervisible;
                    var userPreferedColumns = orderAndHideColumns(userChangedColumns, defaultColumns);
                    setColumns(userPreferedColumns);
                    setCallSaveApiForOrderVisibility(false);
                }
            }).catch(function (error) {
                if (error.response !== undefined) {
                    setAlertBoxState({ ...alertBoxState, openAlert: true, message: error.response.data.message, severity: "error" });
                }
            });
        }
    }, [preference]);

    useEffect(() => {
        setIntialParamBodyApiCall(false);
        setTableLoadingStatus(true);
        loadUserPreferences({
            body: {
                screenName: componentList[1].name.props.id,
                tabName: componentList[1].name.props.id,
                userId: 0,
                organization: {},
                entity: {}
            }
        }).then((response) => {
            if (response.data === null) {
                setColumns(columnsForEmailMessageConfig);
                savePreference("visibility", columnsForEmailMessageConfig);
            } else {
                var savedColumnsInResponse = JSON.parse(response.data.preferences);
                var orderedColumns = orderAndHideColumns(
                    savedColumnsInResponse.columnsOrdervisible,
                    columnsForEmailMessageConfig
                );
                setColumns(orderedColumns);
            }
            setIntialParamBodyApiCall(true);
            setParamBody(prev => ({ ...prev })); // ✅ triggers exactly one data fetch
        }).catch(function (error) {
            setTableLoadingStatus(false);
            setIntialParamBodyApiCall(true);
            if (error.response !== undefined) {
                setAlertBoxState({ ...alertBoxState, openAlert: true, message: error.response.data.message, severity: "error" });
            }
        });
    }, [selectedLanguage]);

    useEffect(() => {
        if (intialParamBodyApiCall) {
            setTableLoadingStatus(true);
            setTableData([]);
            CommonService.GetListApi(
                apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen.customsValuationEmailMsgConfig,
                paramBody
            ).then((response) => {
                setTableLoadingStatus(false);
                setTotalRowCount(response.data.totalElements);
                setTableData(response.data.content);
            }).catch(function (error) {
                setTableLoadingStatus(false);
                if (error.response !== undefined) {
                    setAlertBoxState({ ...alertBoxState, openAlert: true, message: error.response.data.message, severity: "error" });
                }
            });
        }
    }, [paramBody, refreshTable]); 

    const closeConfirmationDialog = (confirmed) => {
        setOpenConfirmationDialog(false);
        if (confirmed) {
            CommonService.deleteByIdApi(`${apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen.customsValuationEmailMsgConfig}/${primaryKeyOfSelectedRow}`, {})
                .then((response) => {
                    setAlertBoxState({ ...alertBoxState, openAlert: true, message: <FormattedMessage id="BpEmailCommConfig.snackbar.deletemsg" defaultMessage="Email contact deleted successfully" />, severity: "success" });
                    setRefreshTable(!refreshTable);
                })
                .catch(function (error) {
                    let message = (error.response.data !== undefined || error.response.data !== null) ? error.response.data.message
                        : <FormattedMessage id="BpEmailCommConfig.snackbar.error" defaultMessage="Error occurred while deleting Email contact!" />;
                    setAlertBoxState({ ...alertBoxState, openAlert: true, message: message, severity: "error" });
                });
        }
    }

    const handleDelete = (primaryKey, nameToBeDisplacedOnConfirmationDialog, projectCode) => {
        setPrimaryKeyOfSelectedRow(primaryKey);
        setConfirmationMessage(<FormattedMessage id="Are You Sure, You Want To Delete?" />);
        setOpenConfirmationDialog(true);
    }

    if (columns.length > 0) {

        const validFromDateColumn = columns.find((column) => column.field === columnFieldsName.validFrom);
        const validFromDateColIndex = columns.findIndex((col) => col.field === columnFieldsName.validFrom);

        const validFromDateFilterOperators = getGridDateOperators().map(
            (operator) => ({
                ...operator,
                InputComponent: CustomFilters.DateInputValue,
            }),
        );

        columns[validFromDateColIndex] = {
            ...validFromDateColumn,
            filterOperators: validFromDateFilterOperators,
        };

        const validToDateColumn = columns.find((column) => column.field === columnFieldsName.validTo);
        const validToDateColIndex = columns.findIndex((col) => col.field === columnFieldsName.validTo);

        const validToDateFilterOperators = getGridDateOperators().map(
            (operator) => ({
                ...operator,
                InputComponent: CustomFilters.DateInputValue,
            }),
        );

        columns[validToDateColIndex] = {
            ...validToDateColumn,
            filterOperators: validToDateFilterOperators,
        };
    }

    const filterableColumns = useMemo(() => GetFilterableColumns(columns), [columns])

    const key = "columnField"

    const applyFilter = () => {
        let project = null;
        let validFrom = null;
        let validTo = null;
        selectedFilters.map((columns) => {
            switch (columns.columnField) {
                case 'project':
                    project = columns.value
                    break;
                case 'validFrom':
                    validFrom = columns.value
                    break;
                case 'validTo':
                    validTo = columns.value
                    break;
            }
        })

        setParamBody(prevState => {
            return {
                ...prevState, body: {
                    project: project,
                    validFrom: validFrom,
                    validTo: validTo,
                    // bpCode: bpCode,
                    // bpType: bpType
                }
            }
        })
    }

    useEffect(() => {
        setFilterCount([...new Map(selectedFilters.map(item => [item[key], item])).values()].length)
    }, [selectedFilters, tableData])

    return (
        <React.Fragment>
            <CssBaseline />
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={openAlert}
                onClose={handleCloseAlert}
                key={vertical + horizontal}
                autoHideDuration={6000}
            >
                <Alert onClose={handleCloseAlert} severity={severity}>
                    {message}
                </Alert>
            </Snackbar>
            <Grid container className={classes.rootForRole}>
                <Grid item container justifyContent='flex-start' alignItems='center' xs={6} sm={8} md={6} lg={6} className={classes.topGrid}>
                    <CustomBreadCrumb componentList={componentList} />
                </Grid>
                <CustomFilterComponent open={openFilterPanel} onClose={handleClose} filterableColumns={filterableColumns}
                    setSelectedFilters={setSelectedFilters} selectedFilters={selectedFilters} applyFilter={applyFilter}
                    defaulSelectedFilters={defaulSelectedFilters} />
                <Paper elevation={3} className={classes.gridHeightAndWidthForRole}>
                    <div style={{ height: '100%', width: '100%', overflow: 'auto' }}>
                        <DataGridPro
                            className={classes.customTableStyle}
                            sortingMode="server"
                            rows={tableData}
                            columns={columns}
                            pageSize={paramBody.recordsPerPage}
                            loading={tableLoadingStatus}
                            rowCount={totalRowCount}
                            scrollbarSize={30}
                            disableColumnFilter={true}
                            rowsPerPageOptions={[1, 2, 10, 25, 50, 100]}
                            pagination
                            paginationMode="server"
                            disableSelectionOnClick={true}
                            disableColumnMenu={false}
                            disableMultipleColumnsSorting={true}
                            hideFooter={true}
                            localeText={localtext}
                            density="compact"
                            getRowId={(row) => row.custValConfigId}
                            onPageSizeChange={((pageParams) => {
                                setParamBody(prevState => { return { ...prevState, recordsPerPage: pageParams } })
                            })}
                            onPageChange={((pageParams) => {
                                setParamBody(prevState => { return { ...prevState, pageNo: (pageParams) } })
                            })}
                            onSortModelChange={(params) => {
                                let sortModel = params[0];
                                if (sortModel !== undefined) {
                                    setParamBody({ ...paramBody, sortDir: sortModel.sort, sortKey: sortModel.field });
                                }
                            }}
                            onColumnVisibilityChange={((params) => {
                                if (params.field !== '__check__') {
                                    var visibleColumns = columns;
                                    var index = visibleColumns.findIndex(element => element.field === params.field);
                                    visibleColumns[index].hide = !params.isVisible;
                                    savePreference("visibility", visibleColumns);
                                }
                            })}
                            onColumnOrderChange={((params) => {
                                var OrderedColumns = columns;
                                var reOrderedColumns = OrderedColumns.splice(params.oldIndex, 1);
                                OrderedColumns.splice(params.targetIndex, 0, reOrderedColumns[0]);
                                savePreference("order", OrderedColumns);
                            })}
                            components={{
                                Toolbar: () => {
                                    return (
                                        <Grid container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="center" style={mobileScreen ? { marginBottom: '-0.1%', marginTop: '0%' } : { marginBottom: '-0.3%', marginTop: '-0.5%' }}>
                                            <Grid
                                                item
                                                container
                                                direction="row"
                                                justifyContent="flex-start"
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                lg={6}>
                                                <Grid>
                                                    <Tooltip title={<FormattedMessage id="common.columntoolbar.tooltip" defaultMessage={pageLabelsConstantsAndMessages.label.columns} />} placement='bottom'>
                                                        <GridToolbarColumnsButton className={classes.toobarStyle} variant="outlined" size="medium" />
                                                    </Tooltip>
                                                </Grid>
                                                <Grid>
                                                    <Tooltip title={<FormattedMessage id="common.density.tooltip" defaultMessage={pageLabelsConstantsAndMessages.label.Density} />}
                                                        placement='bottom'>
                                                        <GridToolbarDensitySelector className={classes.toobarStyle} variant="outlined" size="medium" />
                                                    </Tooltip>
                                                </Grid>
                                                <Grid>
                                                    <Tooltip title={<FormattedMessage id="common.button.refresh.tooltip" defaultMessage="Refresh" />} placement='bottom'>
                                                        <span>
                                                            <Button size="small" color="primary" variant="outlined"
                                                                className={classes.refreshToobarStyle}
                                                                onClick={(() => {
                                                                    setRefreshTable(!refreshTable);
                                                                })}>
                                                                <RefreshIcon />
                                                            </Button>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                <Grid>
                                                    {(emailMessageConfigModuleAccess !== undefined ? emailMessageConfigModuleAccess.createFlag : false) && (mode === 'edit') && (<Tooltip title={<FormattedMessage id="common.button.create.breadcrumb.tooltip" defaultMessage="Refresh" />} placement='bottom'>
                                                        <span>
                                                            <Button size="small" color="primary" variant="outlined"
                                                                className={classes.refreshToobarStyle}
                                                                onClick={(() => {
                                                                    setModeForEmailConfig('create');
                                                                    setOpenEmailMessageConfigDialog(true);
                                                                })}
                                                            >
                                                                <CreateIcon />
                                                            </Button>
                                                        </span>
                                                    </Tooltip>)}
                                                    <CustomsValuationEmailEditConfigDialog
                                                        open={OpenEmailMessageConfigDialog}
                                                        onClose={closeEmailMessageConfigDialog}
                                                        title={commonBreadCrumbToBeUsedForDialog}
                                                        mode={modeForEmailConfig}
                                                        emailMessageConfigToBeEdited={emailMessageConfigObjectToBeEditedOrView}
                                                    // supplierObjectToBeEditedOrView={supplierObjectToBeEditedOrView}
                                                    // customerObjectToBeEditedOrView={customerObjectToBeEditedOrView}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <CommonGridPagination />
                                            </Grid>
                                        </Grid>
                                    );
                                },
                            }}
                            sortingOrder={['desc', 'asc']}
                            filterMode="server"
                        />
                    </div>
                </Paper>
                <ConfirmationDialog onClose={closeConfirmationDialog} message={confirmationMessage} open={openConfirmationDialog} />
            </Grid>
        </React.Fragment>
    )
}
export default CustomsValuationEmailMsgConfig;